import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DadoBancarioService } from 'src/app/services/dado-bancario.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
  selector: 'app-tipo-deposito',
  templateUrl: './tipo-deposito.component.html',
  styleUrls: ['./tipo-deposito.component.css']
})
export class TipoDepositoComponent implements OnInit {

  public currentUser: Auth;

  constructor(
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  public NavegarParaTransferencias() {
    this.router.navigate(['../transferencia'], { relativeTo: this.route });
  }

  public NavegarParaBoletos() {
    this.router.navigate(['../boleto'], { relativeTo: this.route });
  }

  public OpenModal(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }
}
